import * as utils from './utils'
import * as utils_auth from './utils_auth'
import { User } from './User'
import store from './store';

const DEBUGGING = process.env.NODE_ENV === 'development'

export type emailTypes = 'confirmEmail' | 'passwordReset'


export class DocsendUser extends User {
  protected static ALLOW_UNEXPECTED_FIELDS: boolean = false   // cuz we set User to true

  public favorites: string[] = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object, username?: string, email?: string, passwordHash?: string) {
    super(null, username, email, passwordHash)
    if (po) this.injectPlainObject(po)
    this.hydrate()
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  public updateMeToStoreAndLocalStorage(): void {
    console.assert(this.isSafe())
    if (store.getters.userId === this.getIdAsString()) utils_auth.saveAuthStuffToStoreAndLocalStorage(this, null)  // save to store
  }

}

(async () => {
})();
